import React, { useContext, useEffect, useMemo, useState } from "react";
import SidebarLeft from "../../components/SidebarLeft";
import SidebarRight from "../../components/SidebarRight";
import { ThemeContext } from "../../components/ThemeProvider";
import FloatingEditModal from "../../components/FloatingEditModal";
import DemoQuestionsFeed from "../../components/DemoQuestionsFeedV2";
import api from "../../api";
import Swal from "sweetalert2";
import Loader from "../../components/Loader";
import { useAuth } from "../../context/AuthContext";
import { useSearch } from "../../context/SearchContext";

function FeedQues() {
  const { theme } = useContext(ThemeContext);
  const [questionGroups, setQuestionGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [activeSort, setActiveSort] = useState("new");
  const { user: loggedInUser } = useAuth();
  const { searchTerm, updateSearch } = useSearch();

  useEffect(() => {
    let metaTag = document.querySelector('meta[name="robots"]');

    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("name", "robots");
      document.head.appendChild(metaTag);
    }

    metaTag.setAttribute("content", "noindex, nofollow");

    return () => {
      metaTag.setAttribute("content", "noindex, nofollow");
    };
  }, []);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        setLoading(true);
        const res = await api.get("/questions", {
          params: { user_id: loggedInUser?.id },
        });
        setQuestionGroups(res.data?.questions || []);
        setSelectedCategory(null);
      } catch (err) {
        Swal.fire("Error!", "Failed to load questions", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, [loggedInUser?.id]);

  const filteredQuestions = useMemo(() => {
    let filtered = [...questionGroups];

    if (selectedCategory) {
      filtered = filtered.filter((group) => group.topic?.id === selectedCategory);
    }

    if (searchTerm.trim()) {
      const query = searchTerm.toLowerCase().replace(/^#+/, "");
      filtered = filtered.filter((group) => {
        const searchableText = [
          group.question,
          group.hashtags,
          group.topic?.name,
          ...(group.posts || []).map((post) => `${post.title || ""} ${post.description || ""}`),
        ].join(" ").toLowerCase();

        return searchableText.includes(query);
      });
    }

    return filtered.sort((a, b) => {
      if (activeSort === "top") {
        const likesA = (a.posts || []).reduce((sum, post) => sum + (post.likes_count || 0), 0);
        const likesB = (b.posts || []).reduce((sum, post) => sum + (post.likes_count || 0), 0);
        return likesB - likesA;
      }

      return new Date(b.updated_at || b.created_at || 0) - new Date(a.updated_at || a.created_at || 0);
    });
  }, [questionGroups, selectedCategory, searchTerm, activeSort]);

  return (
    <div className={`main-layout ${theme}-theme`}>
      <div className="container">
        <div className="content-wrapper" style={{ display: "flex" }}>
          <SidebarLeft
            onCategorySelect={setSelectedCategory}
            selectedCategory={selectedCategory}
            onSearch={updateSearch}
            onFilterChange={setActiveSort}
          />

          <main className="main-section-parent">
            <div className="top-bar-wrapper">
              <SidebarLeft
                onCategorySelect={setSelectedCategory}
                selectedCategory={selectedCategory}
                onSearch={updateSearch}
                onFilterChange={setActiveSort}
              />
            </div>
            {loading ? <Loader /> : <DemoQuestionsFeed items={filteredQuestions} title="Confessions" />}
          </main>

          <SidebarRight />
          <FloatingEditModal defaultCategory={selectedCategory} hideTrigger />
        </div>
      </div>
    </div>
  );
}

export default FeedQues;
